/** @file slotsOfPart: one drawable's slots sorted by entry then tile, with direction and band labels. */
import type { ArtSlot, ViewedSlot } from './artTypes';
import { directionLabel } from './directionLabel';

/** The entry's pitch ranges, then its frame keys and variant flags when it has any: `ALL`, `ALL · frame 1`. */
function bandOf(slot: ViewedSlot): string {
  const parts = [slot.bands.join(' ')];
  if (slot.frames.length > 0) parts.push(`frame ${slot.frames.join(',')}`);
  if (slot.variants.length > 0) parts.push(`+${slot.variants.join('+')}`);
  return parts.join(' · ');
}

/** The slots of `drawable` sorted by entry then tile; `direction` comes from the view's body azimuth. */
export function slotsOfPart(slots: readonly ViewedSlot[], drawable: string): ArtSlot[] {
  return slots
    .filter((s) => s.drawable === drawable)
    .sort((a, b) => a.entry - b.entry || a.tile - b.tile)
    .map((s) => ({ ...s, direction: directionLabel(s.view?.bodyAzimuthDeg), band: bandOf(s) }));
}
